import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotFoundComponent  implements AfterViewInit {
  isLoading = false;
  
  constructor(private authService: AuthService) { }

  ok(): void {
    this.isLoading = true;
    this.authService.navigateToLandingPage();
  }

  ngAfterViewInit() {
    document.getElementById('preloader').classList.add('hide');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/errors/not-found/not-found.component.ts